import { Form, Input, ModalProps, FormProps, Modal, Spin, Row, Col, Select, Divider, useSelect, Space, Button, Typography } from '@pankod/refine-antd'
import { CrudFilter, useGetIdentity, useList, useTable, useCreateMany, useOne, useMany } from '@pankod/refine-core'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs, { Dayjs } from 'dayjs'
import {
  IGrade,
  ISubject,
  ITopic,
  IBloomLevel,
  ICentaStandard,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  ITeacherLevel,
  IReportTheme,
  IUser,
  ITheme,
  ISubTheme,
  IAspect,
  IQuestionStatus,
  INotification,
  IWorkRequestApprover,
  IWorkRequestReviewer,
  ITNTaxonomy,
  ICompetency,
  IStrand,
  IWorkRequestGrades,
  IPaper,
} from 'interfaces'

import sendEmail from 'sendmail'
import { useEffect, useState } from 'react'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import paperMetadata from 'metadata/paper'

import { CreateWorkRequestReviewers, getLastCreatedWorkRequest, getLastCreatedPaperWorkRequest } from 'gql/mutations'

import { DatePicker } from 'antd'
// Save draft btn style

import 'styles/custom.css'
import { useUserContext } from 'context/user'
import { useBloomsLevel, useDifficultyLevels } from 'utility/masterData'
type CreateWorkRequestProps = {
  modalProps: ModalProps
  formProps: FormProps
  close: any
  refreshData?: any
  success: any
  request: any
  gradeList: any
}
const { Text } = Typography

export const CreatePaperWorkRequest: React.FC<CreateWorkRequestProps> = ({
  modalProps,
  formProps,
  close,
  success,
  refreshData,
  request,
  gradeList,
}) => {
  const { data: user } = useGetIdentity()
  const { qcreatorList, qapproverList, qreviewerList, vcreatorList, subjectInChargeUsers } = useUserContext()
  const [requestType, setRequestType] = useState('Q')
  const [subthemeId, setSubthemeId] = useState('')
  // const [qcreatorList, setCreatorList] = useState([] as any[])
  // const [vcreatorList, setVariantCreatorList] = useState([] as any[])
  // const [qreviewewList, setReviewerList] = useState([] as any[])
  // const [qapproverList, setApproverList] = useState([] as any[])
  const [selectedReviewers, setSelectedReviewers] = useState<string[]>([])
  const [reviewers, setReviewers] = useState<object[]>([])
  const [saveAsDraft, setSaveDraft] = useState(false)
  const [disableSaveBtn, setDisableSaveBtn] = useState(false)
  const [totalVariantCount, setTotalVariantCount] = useState<number[]>([])
  const [questionCount, setQuestionCount] = useState(5)
  const [taxonomyfilter, setTaxonomyFilter] = useState([])
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [allReviewers, setAllReviewers] = useState<object[]>([])
  const [showApprover, setShowApprover] = useState<boolean>(false)
  const [selectedReviewersList, setSelectedReviewerList] = useState<string[]>([])
  const [selectedReviewerIds, setSelectedReviewerIDS] = useState<string[]>([])
  const [reloadApproverData, setReloadApproverData] = useState(false)
  const [reloadCreatorData, setResetCreatorData] = useState(false)
  const [reloadVCreatorData, setResetVCreatorData] = useState(false)
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])
  const [paperWorkRequestType, setPaperWorkRequestType] = useState<string>('Normal')

  const [reportThemeQueryEnabled, setReportThemeQueryEnabled] = useState<boolean>(false)
  const [themeQueryEnabled, setThemeQueryEnabled] = useState<boolean>(false)
  const [subThemeQueryEnabled, setSubThemeQueryEnabled] = useState<boolean>(false)
  const [TopicQueryEnabled, setTopicQueryEnabled] = useState<boolean>(false)
  const [questionQueryEnabled, setQuestionQueryEnabled] = useState(false)
  const bloomlevelSelectProps = useBloomsLevel(modalProps?.visible)
  const difficultylevelSelectProps = useDifficultyLevels(modalProps?.visible)
  // const [subjectInchargeList, setSubjectInchargeList] = useState<any[]>([])
  const [gradeArr, setGradeArr] = useState<any[]>([])
  // const [reportThemeData, setReportThemeData] = useState([] as any[])
  var notification_arr: object[] = []
  var mail_arr: object[] = []
  const { mutate } = useCreateMany<INotification>()
  const { mutate: createReviewers } = useCreateMany<IWorkRequestReviewer>()
  const { mutate: createApprovers } = useCreateMany<IWorkRequestApprover>()
  const { mutate: createGrades } = useCreateMany<IWorkRequestGrades>()
  const [validation, setValidation] = useState({
    question_type_id: true,
    subject_id: true,
    creator_id: true,
  })
  const { filters, setFilters, tableQueryResult, sorter } = useTable<ITopic>({
    resource: 'topics',
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    initialPageSize: 500,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    initialFilter: !!request?.report_theme_id ? [{ field: 'report_theme_id', operator: 'eq', value: request?.report_theme_id }] : [],
    metaData: { fields: ['id', 'name', 'subject_id'] },
    initialPageSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    initialFilter: !!request?.theme_id ? [{ field: 'theme', operator: 'eq', value: request?.theme_id }] : [],
    metaData: { fields: ['id', 'name', 'theme_id'] },
    initialPageSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    filters: questionFilter,
    setFilters: setQuestionFilters,
    tableQueryResult: questionResult,
  } = useTable<IQuestion>({
    resource: 'questions',
    metaData: { fields: ['id', 'title'] },
    initialPageSize: 500,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  useEffect(() => {
    setShowApprover(false)
    setAllReviewers([])
    setSelectedReviewerIDS([])
    setDisableSaveBtn(false)
  }, [])

  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs().add(-1, 'day')
  }

  const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
    resource: 'report_themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    // filters: subjectFilter,
    filters: [{ field: 'subject_id', operator: 'eq', value: request?.subject_id }],
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible && !!request?.subject_id },
  })
  const { selectProps: gradeSelectProps } = useSelect<IGrade>({
    resource: 'grades',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,

    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'subjects',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  console.log('DRAFT WORK REQUEST PAPER', modalProps?.visible, modalProps)

  // const { selectProps: bloomlevelSelectProps } = useSelect<IBloomLevel>({
  //   resource: 'blooms_levels',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'order', order: 'asc' }],
  // })
  // const { selectProps: competencySelectProps } = useSelect<ICompetency>({
  //   resource: 'competencies',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })
  // const { selectProps: teacherlevelSelectProps } = useSelect<ITeacherLevel>({
  //   resource: 'teacher_levels',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'id', order: 'asc' }],
  // })
  // const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
  //   resource: 'question_types',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   queryOptions: { enabled: !!modalProps?.visible, staleTime: Infinity },
  // })
  // const { selectProps: workrequestStatusSelectProps } = useSelect<IQuestionStatus>({
  //   resource: 'work_request_statuses',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })
  // const { selectProps: difficultylevelSelectProps } = useSelect<IDifficultyLevel>({
  //   resource: 'difficulty_levels',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'order', order: 'asc' }],
  // })
  // const { selectProps: reportThemeProps } = useSelect<IReportTheme>({
  //   resource: 'report_themes',
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   fetchSize: 100,
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  // })

  const handleRequestType = (value: any) => {
    setRequestType(value)
    formProps?.form?.setFieldsValue({
      creator_id: null,
    })
  }
  const handleSubjectChange = (value: { value: any }) => {
    setSubjectFilter([])
    questionFilter.pop()
    // setReportThemeData([])

    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
      report_theme_id: null,
    })
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setSubjectFilter(data)

    setQuestionFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
    setQuestionQueryEnabled(true)
    setReportThemeQueryEnabled(true)
  }

  useEffect(() => {
    if (request?.subject_id !== undefined) {
      setQuestionFilters([
        {
          field: 'subject_id',
          operator: 'eq',
          value: request?.subject_id,
        },
      ])
    }
    if (request?.no_of_questions !== undefined) {
      setQuestionCount(request?.no_of_questions)
    }
  }, [request])

  const handleReportThemeChange = (value: { value: any }) => {
    themeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      // questionResult: null,
    })
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
    setThemeQueryEnabled(true)
  }
  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
    setSubThemeQueryEnabled(true)
  }
  const handleSubThemeChange = (value: { value: any }) => {
    filters.pop()
    formProps?.form?.setFieldsValue({
      topic_id: null,
    })
    setFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
    setTopicQueryEnabled(true)
  }

  // const { selectProps: tntaxonomySelectProps } = useSelect<ITNTaxonomy>({
  //   resource: 'tn_taxonomys',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name', 'competency_id'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   filters: taxonomyfilter,
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  // const { selectProps: strandSelectProps } = useSelect<IStrand>({
  //   resource: 'strands',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   filters: strandfilter,
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  const handleCompetencyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      taxonomy_id: null,
      teacher_level_id: null,
      strand_id: null,
    })
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
    setStrandFilter(data)
  }
  const handleTaxonomyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      teacher_level_id: null,
      strand_id: null,
    })
    let arr: any[] = [...strandfilter]
    let data: any = {
      field: 'taxonomy_id',
      operator: 'eq',
      value: value,
    }
    arr.push(data)

    setStrandFilter(arr)
  }

  const handleTeacherLevelChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      strand_id: null,
    })
    let arr: any[] = [...strandfilter]
    let data: any = {
      field: 'teacher_level_id',
      operator: 'eq',
      value: value,
    }

    arr.push(data)

    setStrandFilter(arr)
  }

  const changeApprover = (value: string[], rid: string) => {
    allReviewers.map((item: any, index: any) => {
      if (item?.reviewer?.id === rid) {
        let app_data: object[] = []
        let app_ids: string[] = []
        if (app_ids === undefined) {
          app_ids = []
        }
        for (let i = 0; i < value.length; i++) {
          app_data.push(qapproverList?.filter((list: any) => list?.id === value[i])[0])

          app_ids.push(qapproverList?.filter((list: any) => list?.id === value[i])[0]?.id)
          app_data = app_data.filter((thing: any, index: any, self: any) => index === self.findIndex((t: any) => t.id === thing.id))
          app_ids = app_ids.filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) == index
          })
        }
        item['approver_ids'] = app_data
        item['ap_ids'] = app_ids
      }
    })
    setReloadApproverData(true)
  }
  const onFinish = async (values: any) => {
    setDisableSaveBtn(true)
    let approverData: object[] = []
    let allApproverData: object[] = []
    allReviewers.map((item: any, i: any) => {
      delete values['approver_ids_' + i]
      delete values['reviwer_id_selected_' + i]

      if (selectedReviewerIds.includes(item?.reviewer?.id)) {
        item?.ap_ids.map((ids: any) => {
          allApproverData.push(ids)
        })

        approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
      }
    })
    allApproverData = allApproverData.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })

    //subject_incharge_id
    const subjectInchargeDetails = subjectInChargeUsers?.filter(user => user?.id === values?.subject_incharge_id)[0]
    mail_arr.push({
      subject: 'Work Request Created and assigned to you',
      to: [{ name: subjectInchargeDetails?.displayName, email: subjectInchargeDetails?.email }],
      htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. You can assign creators and reviewers and approvers as per your requirements.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
    })
    notification_arr.push({
      description: `You are assigned as the subject incharge for work request ${values?.name} `,
      sender: user?.id,
      recepient: subjectInchargeDetails?.id,
      source_name: 'work_requests',
      title: 'New Task',
      recepient_user_role: 'subjectincharge',
    })

    if (JSON.stringify(values?.reviewer_ids) !== '{}' && values?.reviewer_ids !== null && values?.reviewer_ids !== undefined) {
      values?.reviewer_ids.map((item: any) => {
        notification_arr.push({
          description: `You are assigned as reviewer for work request ${values?.name} `,
          sender: user?.id,
          recepient: item,
          source_name: 'work_requests',
          title: 'New Task',
          recepient_user_role: 'qreviewer',
        })
        let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === item)[0]
        mail_arr.push({
          subject: 'Work Request Created and assigned to you',
          to: [{ name: reviewerDetails?.displayName, email: reviewerDetails?.email }],
          htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. Questions to review will assign shortly.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
        })
      })
    }
    if (approverData.length > 0) {
      approverData?.map((item: any) => {
        item?.approver_ids.map((approver: any) => {
          notification_arr.push({
            description: `You are assigned as approver for work request ${values?.name}`,
            sender: user?.id,
            recepient: approver,
            source_name: 'work_requests',
            title: 'New Task',
            recepient_user_role: 'qapprover',
          })
          let approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approver)[0]
          mail_arr.push({
            subject: 'Work Request Created and assigned to you',
            to: [{ name: approverDetails?.displayName, email: approverDetails?.email }],
            htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. Question to approve will assign shortly.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
          })
        })
      })
    }
    if (values?.creator_id !== '' && values?.creator_id !== null && values?.creator_id !== undefined) {
      notification_arr.push({
        description: 'Work Request created and assigned to you',
        sender: user?.id,
        recepient: values?.creator_id,
        source_name: 'work_requests',
        title: 'New Task',
        recepient_user_role: requestType === 'Q' ? 'qcreator' : 'variantcreator',
      })
      let creatorDetails = []
      if (requestType === 'Q') {
        creatorDetails = qcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }
      if (requestType === 'V') {
        creatorDetails = vcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }

      mail_arr.push({
        subject: 'Work Request Created and assigned to you',
        to: [{ name: creatorDetails?.displayName, email: creatorDetails?.email }],
        htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} and assigned to you. You have to create ${values?.count} questions.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
      })
    }

    let count = questionCount
    if (requestType === 'V') {
      count = 0
      values?.variant_options?.map((item: any) => {
        count = count + parseInt(item?.variant_count)
      })
    }
    if (saveAsDraft === true) {
      setSaveDraft(false)

      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: 'Draft',
          count: count,
          approver_ids: approverData,
          all_approver_ids: allApproverData,
          //   subject_id: values?.subject_id !== '' ? values?.subject_id : null,
          //   question_type_id: values?.question_type_id !== '' ? values?.question_type_id : null,
          creator_id: values?.creator_id !== '' ? values?.creator_id : null,
          reviewer_ids: values?.reviewer_ids ?? [],
        })
      )
    } else {
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: 'Open',
          count: count,
          approver_ids: approverData,
          all_approver_ids: allApproverData,
          reviewer_ids: values?.reviewer_ids ?? [],
        })
      )
    }
  }
  const reviewerChange = (value: string[]) => {
    let arr: object[] = []
    let ids: string[] = []
    let all_data = [...allReviewers]
    if (value.length > 0) {
      for (let i = 0; i < value?.length; i++) {
        const result = qreviewerList?.filter((item: any) => item?.id === value[i])[0]

        arr.push(result)
        ids.push(value[i])
        all_data.push({ reviewer: result, approver_ids: [], ap_ids: [] })
      }
      ids = ids.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })

      all_data = all_data.filter(
        (elem: any, index: any, self: any) =>
          self.findIndex((t: any) => {
            return t?.reviewer?.id === elem?.reviewer?.id
          }) === index
      )
      console.log('after', all_data, ids)
      setAllReviewers(all_data)
      setSelectedReviewerIDS(ids)
      setReviewers(arr)
    } else {
      setAllReviewers([])
      setSelectedReviewerIDS([])
      setReviewers([])
    }
  }

  const addApprover = () => {
    setShowApprover(true)
  }

  useEffect(() => {
    if (gradeList !== undefined && request !== undefined) {
      formProps?.form?.setFieldsValue({
        grade_ids: gradeList,
        question_type_id: request?.question_type_id,
        subject_id: request?.subject?.id,
        theme_id: request?.theme?.id,
        report_theme_id: request?.report_theme?.id,
        sub_theme_id: request?.sub_theme?.id,
        topic_id: request?.topic?.id,
        count: request?.no_of_questions,
        paper_id: request?.paperId,
        bloom_level_id:request?.bloom_level?.id,
        difficulty_level_id:request?.difficulty_level?.id
      })
    }
  }, [gradeList, request])

  return (
    <Modal
      {...modalProps}
      title="Create Work Request"
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      afterClose={() => {
        // reset states
        setPaperWorkRequestType('Normal')
        formProps?.form?.resetFields()
        setRequestType('Q')
      }}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          let work_request_id = ''
          onFinish(values).then(response => {
            // if (success === true) {
            getLastCreatedWorkRequest()
              .then((resp: any) => {
                work_request_id = resp?.work_requests?.[0]?.id
              })
              .then(() => {
                let reviwer_arr: object[] = []
                let approver_arr: object[] = []
                if (values?.reviewer_ids !== null && values?.reviewer_ids !== undefined && JSON.stringify(values?.reviewer_ids) !== '{}') {
                  values?.reviewer_ids?.map((item: any) => {
                    reviwer_arr.push({ user_id: item, work_request_id: work_request_id })
                  })

                  createReviewers({
                    resource: 'work_request_reviewers',
                    values: reviwer_arr,
                  })
                }
                let approverData: object[] = []

                allReviewers.map((item: any, i: any) => {
                  delete values['approver_ids_' + i]
                  if (selectedReviewerIds.includes(item?.reviewer?.id))
                    approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
                })
                if (approverData.length > 0) {
                  approverData?.map((item: any) => {
                    item?.approver_ids.map((approver: any) => {
                      approver_arr.push({ approver_id: approver, work_request_id: work_request_id, reviewer_id: item?.reviwer_id_selected })
                    })
                  })
                  createApprovers({
                    resource: 'work_request_approvers',
                    values: approver_arr,
                  })
                }
                refreshData()
                if (!saveAsDraft) {
                  sendEmail(mail_arr)
                  notification_arr.map((item: any) => {
                    item['redirect_id'] = work_request_id
                    item['redirect_component'] = 'show'
                    // item.push({
                    //   redirect_id: work_request_id,
                    //   redirect_component: 'show',
                    // })
                  })
                  mutate({
                    resource: 'notifications',
                    values: notification_arr,
                  })
                }
                // refreshData()
              })
              .then(() => {
                let grade_array: object[] = []
                if (values?.grade_ids?.length > 0) {
                  values?.grade_ids?.map((item: any) => {
                    grade_array.push({
                      grade_id: item,
                      work_request_id: work_request_id,
                    })
                  })

                  createGrades({
                    resource: 'work_request_grades',
                    values: grade_array,
                  })
                }
              })
              .then(() => {
                setDisableSaveBtn(false)
                setShowApprover(false)
                setAllReviewers([])
                setSelectedReviewerIDS([])
                setDisableSaveBtn(false)
              })
            // }
          })
        }}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Work Request Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={16}>
            <Form.Item label="Description" name="description">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={12}>
            <Form.Item label="Request Type" name="request_type" initialValue={'Q'} rules={[{ required: true }]}>
              <Select
                allowClear
                onChange={handleRequestType}
                options={[
                  { label: 'Question', value: 'Q' },
                  { label: 'Variant', value: 'V' },
                ]}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={12}>
            <Form.Item label="Paper Work Request Type" name="paper_wr_type" initialValue={'Normal'} rules={[{ required: true }]}>
              <Select
                allowClear
                // onChange={handleRequestType}
                onChange={value => setPaperWorkRequestType(value)}
                options={[
                  { label: 'Normal Request', value: 'Normal' },
                  { label: 'Urgent Request', value: 'Urgent' },
                ]}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Status" name="status" initialValue={'Open'} rules={[{ required: true }]}>
              <Select {...workrequestStatusSelectProps} />
            </Form.Item>
          </Col> */}
          <Col xs={24} lg={8}>
            <Form.Item
              label="Question Type"
              name="question_type_id"
              initialValue={request?.question_type_id}
              rules={[{ required: validation?.question_type_id }]}
            >
              <Select
                // {...questionTypeSelectProps}
                defaultValue={{ label: request?.question_type?.name, value: request?.question_type?.id }}
                allowClear
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Due Date"
              name="due_date"
              rules={[{ required: true }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker style={{ width: '100%' }} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item label="Grade" name="grade_ids" rules={[{ required: false }]} initialValue={gradeArr?.map(data => data?.id)}>
              <Select {...gradeSelectProps} mode="multiple" allowClear showSearch={false} disabled>
                {gradeArr?.map(gradeData => (
                  <option key={gradeData.id} value={gradeData?.id}>
                    {gradeData?.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Subject" name="subject_id" rules={[{ required: validation?.subject_id }]} initialValue={request?.subject?.id}>
              <Select
                {...subjectSelectProps}
                defaultValue={{ label: request?.subject?.name, value: request?.subject?.id }}
                onChange={handleSubjectChange}
                allowClear
                disabled
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} lg={8}>
            <Form.Item
              label="Report Theme (TN_Term_Month)"
              name="report_theme_id"
              rules={[{ required: false }]}
              initialValue={request?.report_theme_id}
            >
              <Select
                {...reportThemeSelectProps}
                // disabled={
                //   formProps?.form?.getFieldValue('subject_id') === undefined || formProps?.form?.getFieldValue('subject_id') == null ? true : false
                // }
                disabled={!!request?.report_theme_id}
                onChange={handleReportThemeChange}
                allowClear
                defaultValue={{ label: request?.theme?.name, value: request?.theme?.id }}
              />
            </Form.Item>
          </Col> */}
          <Col xs={24} lg={8}>
            <Form.Item label="Theme" name="theme_id" rules={[{ required: false }]} initialValue={request?.theme?.id}>
              <Select
                defaultValue={{ label: request?.theme?.name, value: request?.theme?.id }}
                showSearch
                allowClear
                onChange={handleThemeChange}
                // disabled={
                //   formProps?.form?.getFieldValue('report_theme_id') === undefined || formProps?.form?.getFieldValue('report_theme_id') === null
                //     ? true
                //     : false
                // }
                disabled={!!request?.theme_id}
              >
                {themeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Sub Theme" name="sub_theme_id" rules={[{ required: false }]}>
              <Select
                defaultValue={{ label: request?.sub_theme?.name, value: request?.sub_theme?.id }}
                onChange={handleSubThemeChange}
                allowClear
                // disabled={
                //   formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false
                // }
                disabled={!!request?.sub_theme_id}
              >
                {subThemeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Topic (TN Taxonomy ID/s)" name="topic_id" rules={[{ required: false }]} initialValue={request?.topic?.id}>
              {/* <TopicSelector /> */}
              {/* <Select {...topicSelectProps} /> */}
              <Select
                defaultValue={{ label: request?.topic?.name, value: request?.topic?.id }}
                allowClear
                // disabled={
                //   formProps?.form?.getFieldValue('sub_theme_id') === undefined || formProps?.form?.getFieldValue('sub_theme_id') == null
                //     ? true
                //     : false
                // }
                disabled={!!request?.topic_id}
              >
                {tableQueryResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item> 
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate Bloom's taxonomy level"  name="bloom_level_id" initialValue={request?.bloom_level?.id} rules={[{ required: false }]}>
              <Select 
              {...bloomlevelSelectProps} 
              allowClear 
              disabled={!!request?.blooms_level_id}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" initialValue={request?.difficulty_level?.id} rules={[{ required: false }]}>
              <Select 
              {...difficultylevelSelectProps} 
              allowClear 
              disabled={!!request?.difficult_level_id}
              />
            </Form.Item>
          </Col>
          {requestType === 'Q' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Number of Questions (Fill in with either 9 or 25)"
                name="count"
                initialValue={request?.no_of_questions}
                rules={[{ required: true }]}
              >
                <Input onChange={e => setQuestionCount(parseInt(e.target.value))} defaultValue={request?.no_of_questions} />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item label=" Choose the Subject Incharge's name" name="subject_incharge_id" rules={[{ required: true }]}>
              <Select
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {subjectInChargeUsers.length > 0 &&
                  subjectInChargeUsers.map(eachUser => (
                    <option key={eachUser?.id} value={eachUser?.id}>
                      {eachUser?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {requestType === 'Q' && paperWorkRequestType === 'Urgent' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the Creator's name" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onSearch={value => searchUser('qcreator', value)}
                  // filterOption={false}
                  onChange={() => setResetCreatorData(true)}
                >
                  {qcreatorList.length > 0 &&
                    qcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
                {/* <Select />{" "} */}
              </Form.Item>
            </Col>
          ) : requestType === 'V' && paperWorkRequestType === 'Urgent' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Variant Creator" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  // onChange={() => setResetVCreatorData(true)}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onSearch={value => searchUser('variantcreator', value)}
                  // filterOption={false}
                >
                  {vcreatorList.length > 0 &&
                    vcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
                {/* <Select />{" "} */}
              </Form.Item>
            </Col>
          ) : null}

          {paperWorkRequestType === 'Urgent' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the Reviewer's name (if known)" name="reviewer_ids" rules={[{ required: false }]}>
                <Select
                  mode="multiple"
                  onChange={reviewerChange}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onSearch={value => searchUser('qreviewer', value)}
                  // filterOption={false}
                >
                  {qreviewerList.length > 0 &&
                    qreviewerList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
          <Col xs={24} lg={24}>
            {showApprover
              ? allReviewers.length > 0 &&
                allReviewers.map((elem: any, i: any) => (
                  <Row
                    key={i}
                    gutter={[16, 0]}
                    style={{ display: selectedReviewerIds.length > 0 && !selectedReviewerIds.includes(elem?.reviewer?.id) ? 'none' : 'flex' }}
                  >
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Reviewer"
                        name={'reviwer_id_selected_' + i}
                        rules={[
                          {
                            required: false,
                            message: 'Select a Reviewer',
                          },
                        ]}
                      >
                        <Input placeholder={elem?.reviewer?.displayName} defaultValue={elem?.reviewer?.displayName} readOnly />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                      <Form.Item
                        label="Choose the Approver's name (if known)"
                        name={'approver_ids_' + i}
                        rules={[{ required: false, message: 'Select an Approver' }]}
                      >
                        <Select
                          mode="multiple"
                          allowClear
                          showSearch
                          filterOption={(input: any, option: any) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                            option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          // onSearch={value => searchUser('qapprover', value)}
                          // filterOption={false}
                          defaultValue={elem?.ap_ids}
                          onChange={(value: any) => changeApprover(value, elem?.reviewer?.id)}
                        >
                          {qapproverList.length > 0 &&
                            qapproverList?.map(item => (
                              <option key={item?.id} value={item?.id}>
                                {item?.displayName}
                              </option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                ))
              : null}
            {paperWorkRequestType === 'Urgent' ? (
              <Form.Item>
                <Button type="dashed" onClick={() => addApprover()} block icon={<PlusOutlined />}>
                  Add Approver
                </Button>
              </Form.Item>
            ) : null}
          </Col>
          {/* <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Competency" name="competency_id" rules={[{ required: false }]}>
              <Select allowClear onChange={handleCompetencyChange} {...competencySelectProps} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Taxonomy" name="taxonomy_id" rules={[{ required: false }]}>
              <Select allowClear onChange={handleTaxonomyChange} {...tntaxonomySelectProps} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Strand" name="strand_id" rules={[{ required: false }]}>
              <Select allowClear {...strandSelectProps} />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Teacher Level" name="teacher_level_id" rules={[{ required: false }]}>
              <Select onChange={handleTeacherLevelChange} {...teacherlevelSelectProps} />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Blooms Level" name="bloom_level_id" rules={[{ required: false }]}>
              <Select {...bloomlevelSelectProps} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Difficulty Level" name="difficulty_level_id" rules={[{ required: false }]}>
              <Select {...difficultylevelSelectProps} allowClear />
            </Form.Item>
          </Col> */}

          {requestType === 'V' ? (
            <>
              <Col xs={24} lg={24}>
                <Divider orientation="left" orientationMargin="0" className="primary">
                  Add Variants
                </Divider>
              </Col>
              <Col xs={24} lg={24}>
                <Form.List name="variant_options">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row gutter={[16, 0]}>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              {...restField}
                              label="Variant Question"
                              name={[name, 'question_id']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Select a Question',
                                },
                              ]}
                            >
                              <Select allowClear>
                                {questionResult?.data?.data?.map(item => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.title}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={8}>
                            <Form.Item
                              {...restField}
                              label="Variant Count"
                              name={[name, 'variant_count']}
                              rules={[{ required: true, message: 'Missing Count' }]}
                            >
                              <Input placeholder="Variant Count" type="small" />
                            </Form.Item>
                          </Col>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Row>
                        // </Space>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add Variants
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </>
          ) : null}

          <Form.Item name="created_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="paper_id" initialValue={request?.paperId}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
        <Divider />
        <Row gutter={[16, 0]} justify="end" align="top">
          <Spin spinning={disableSaveBtn}></Spin>
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button onClick={() => close()}>Cancel</Button>
              <Button type="primary" htmlType="submit" disabled={disableSaveBtn}>
                Submit
              </Button>
              <Button
                className="save-draft-btn"
                htmlType="submit"
                onClick={() => {
                  setValidation({ question_type_id: false, subject_id: false, creator_id: false })
                  setSaveDraft(true)
                }}
              >
                Save Draft
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
